export const disableSlider = [
  '',
  `mutation disableSlider($id:Int!) {
        disableSlider(id:$id)
      }
    `,
  'disableSlider'];
